import { FC } from 'react';

import { BasketBlockEmpty } from '@/components/modules/basket-page/basket-block-empty';
import { BasketBlockFull } from '@/components/modules/basket-page/basket-block-full';
import { TVariantsCreditProducts } from '@/components/modules/caclulator/types';

import { TRentProduct } from '@/entities/product';

type TProps = {
    products: TRentProduct[];
    variantsCreditProducts: TVariantsCreditProducts;
};

export const BasketBlocks: FC<TProps> = ({ products, variantsCreditProducts }) => {
    if (products.length === 0) {
        return <BasketBlockEmpty />;
    }

    return <BasketBlockFull products={products} variantsCreditProducts={variantsCreditProducts} />;
};
